import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
const SvgCzechRepublic = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        style: {
            enableBackground: "new 0 0 512 512"
        },
        xmlSpace: "preserve",
        width: "1em",
        height: "1em",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                style: {
                    fill: "#41479b"
                },
                d: "M32.804 32.804C12.536 53.072 0 81.072 0 112v288c0 30.928 12.536 58.928 32.804 79.196L256 256 32.804 32.804z"
            }),
            /*#__PURE__*/ _jsx("path", {
                style: {
                    fill: "#ff4b55"
                },
                d: "M32.804 479.196C53.072 499.464 81.072 512 112 512h288c61.856 0 112-50.144 112-112V256H256L32.804 479.196z"
            }),
            /*#__PURE__*/ _jsx("path", {
                style: {
                    fill: "#f5f5f5"
                },
                d: "M400 0H112C81.072 0 53.072 12.536 32.804 32.804L256 256h256V112C512 50.144 461.856 0 400 0z"
            })
        ]
    });
export { SvgCzechRepublic };
